<template>
  <div>
    <Navbar v-if="$route.name == 'partners'"/>
    <!-- <Breadcrumb v-if="$route.name == 'partners'" /> -->
    <div v-show="partner_id == 0" class="container-fluid">
      <div class="row mt-3 mb-3 align-items-center">
        <div class="col-4 d-flex gap-2">
          <button @click.prevent.stop="addpartner" class="btn btn-sm btn-primary gdq_faded text-nowrap">
            <span class="icon-plus me-2"></span>Add partner
          </button>
          <select 
            v-model="bulkaction" 
            @change="bulkaddlabel" 
            class="form-select form-select-sm"
            style="min-width: 120px;"
          >
            <option value=0 class="text-muted">Bulk action</option>
            <option value=1>Add label</option>
            <option value=2>Do something else</option>
          </select>
          
          <!-- Bulk add label input -->
          <div v-show="bulkaction==1" class="input-group input-group-sm" style="min-width: 200px;">
            <input
              class="form-control form-control-sm"
              v-model="bulkaddlabeltext"
              placeholder="Add label to selected"
              type="text"
              list="labellist"
              @keyup.enter.prevent="savebulkaddlabel"
              @keyup.escape.prevent="bulkaction = 0; bulkaddlabeltext = ''"
              ref="bulkaddlabelinput"
              autocomplete="off"
            >
            <span class="input-group-text">
              <button
                class="btn btn-link btn-sm p-0"
                @click="bulkaction = 0; bulkaddlabeltext = ''"
              >
              X
              </button>
            </span>
          </div>
        </div>

        <div class="col-5 d-flex align-items-center gap-2">
          <span class="text-nowrap">Filter:</span>
          <LabelSelect 
            @input="onLabelFilterChange" 
            v-model="filterlabel" 
            :options="alllabels" 
            class="flex-grow-1" 
            placeholder="All labels"
          />
        </div>

        <div class="col-3">
          <div class="input-group input-group-sm">
            <input
              v-model="search"
              placeholder="Search name or e-mail"
              type="text"
              @input="partners_filter"
              autocomplete="off"
              class="form-control"
            >
            <span class="input-group-text">
              <button
                class="btn btn-link btn-sm p-0"
                @click="search = ''"
              >
              X
              </button>
            </span>
          </div>
        </div>
      </div>
      
      <table class="table table-hover" id="partners">
        <thead>
          <tr>
            <th @click="partners_sort({sortBy: 'select'})">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  @click.stop
                  @change="selectall(selected)"
                  v-model="selected"
                >
                <span class="text-muted" v-if="selectcount>0">({{selectcount}})</span>
              </div>
            </th>
            <th @click="partners_sort({sortBy: 'partner_name', sortDesc: !orderdesc})" style="cursor: pointer;">
              Name
              <span v-if="orderby === 'partner_name'">{{ orderdesc ? '▼' : '▲' }}</span>
            </th>
            <th class="col-5">Labels</th>
            <th class="col-1"></th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr 
            v-for="(item, index) in partners" 
            :key="item.id"
            @click="editpartner(item)"
            style="cursor: pointer;"
          >
            <td>
              <div class="py-1">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :id="'selected'+index"
                    v-model="item.selected"
                    @change="countselected"
                    @click.stop
                  >
                </div>
              </div>
            </td>
            <td>
              <div class="py-1">
                {{ item.partner_name }}
              </div>
            </td>
            <td>
              <div class="form-inline py-0">
                <span v-bind:key="label.id" v-for="label in item.labels" :style="{'background': '#'+label.color}" class="me-2 py-1 ps-2 pe-2 rounded">
                  {{ label.label }}
                  <span 
                    @click.stop.prevent="removelabel(item.id,label.id)"
                    class="ms-2"
                  >
                    <fa-icon name="trash-alt" />
                  </span>
                </span>
                <span 
                  v-show="addinglabel==0"
                  class="icon-plus pt-0 text-secondary"
                  :class="item.labels.length==0?'pt-2':'pt-0'"
                  @click.stop.prevent="addlabel(item.id)"
                >
                </span>
      
                <div 
                  v-show="addinglabel==item.id"
                  class="input-group input-group-sm col-3 ps-0 ms-0 py-0 my-0"
                >
                  <input
                    class="form-control form-control-sm py-0"
                    v-model="addinglabeltext"
                    placeholder="Add label"
                    type="text"
                    list="labellist"
                    @keyup.enter.prevent="saveaddlabel"
                    @keyup.escape.prevent="addinglabel = 0"
                    :ref="'l'+item.id"
                    autocomplete="off"
                  >
                  <span class="input-group-text py-0">
                    <button
                      class="btn btn-link btn-sm p-0"
                      @click="addinglabel = 0"
                    >
                    X
                    </button>
                  </span>
                  <datalist id="labellist">
                    <option :key="label.id" v-for="label in alllabels">{{ label.label }}</option>
                  </datalist>
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center text-danger my-2">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      
      <Pagination
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-label="Partners pagination"
        @page-changed="currentPage = $event"
      />
    </div>
    <div v-show="partner_id != 0">
      <Partner />
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
import _ from 'lodash';
import LabelSelect from './LabelSelect';
import Partner from './Partner';
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
import Pagination from './Pagination.vue';

const fields = [
  { key: 'select', label: '', sortable: false },
  { key: 'partner_name', label: 'Name', sortable: true },
  { key: 'labels', label: 'Labels', sortable: false, tdClass: 'col-5' },
  { key: 'empty', label: '', sortable: false, tdClass: 'col-1' },
];
export default {
  components: {
    Partner,
    LabelSelect,
    Navbar,
    // Breadcrumb,
    Pagination,
  },
  name: 'Partners',
  mounted() {
    this.partners_get()
    this.labels_get();
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      partners: [],
      allowmultiselect: false,
      muteclass: 'text-muted',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: 'partner_name',
      orderdesc: false,
      selected: 0,
      addinglabel: 0,
      addinglabeltext: '',
      filterlabel: 0,
      alllabels: [],
      filterusergroup: 0,
      bulkaction: 0,
      selectcount: 0,
      bulkaddlabeltext: '',
    }
  },
  computed: {
    partner_id: {
      get() {
        return this.$store.state.currentpartner_id;
      }
    },
    partnerchanged: {
      get() {
        return this.$store.state.partnerchanged;
      }
    },
    partnerlabelchanged: {
      get() {
        return this.$store.state.partnerlabelchanged;
      }
    },
  },
  watch: {
    currentPage: function() {
      this.partners_get();
    },
    search: function() {
      this.searching = true
      this.partners_filter()
    },
    partnerchanged: function() {
      if (this.$store.state.partnerchanged != 0) {
        this.partner_get(this.$store.state.partnerchanged);
        this.$store.dispatch('partnerchanged_set',{ partner_id: 0 });
      }
    },
    partnerlabelchanged: function() {
      if (this.$store.state.partnerlabelchanged != 0) {
        this.conlabels_get(this.$store.state.partnerlabelchanged);
        this.$store.dispatch('partnerlabelchanged_set',{ partner_id: 0 });
      }
    },
    partner_id: function(newVal, oldVal) {
      // Only reload the list when coming back from detail view (going from non-zero to 0)
      if (oldVal !== 0 && newVal === 0) {
        this.partners_get();
      }
    },
  },
  methods: {
    bulkaddlabel() {
      if (this.bulkaction == 1) {
        this.$nextTick(() => {
          if (this.$refs.bulkaddlabelinput) {
            this.$refs.bulkaddlabelinput.focus();
          }
        });
      }
    },
    savebulkaddlabel() {
      if (this.bulkaddlabeltext != '' && this.selectcount > 0) {
        // Add label to all selected partners
        const selectedPartners = this.partners.filter(p => p.selected);
        const promises = selectedPartners.map(partner => {
          const savelabel = {
            partner_id: partner.id,
            label: this.bulkaddlabeltext,
          };
          return this.$store.dispatch('partnerlabel_add', { label: savelabel });
        });
        
        Promise.all(promises).then(() => {
          this.labels_get();
          // Refresh labels for all selected partners
          selectedPartners.forEach(partner => {
            this.conlabels_get(partner.id);
          });
          this.bulkaction = 0;
          this.bulkaddlabeltext = '';
        });
      }
    },
    addpartner() {
      this.$store.dispatch('partner_setcurrent',{ partner_id: -1 })
    },
    editpartner(item) {
      console.log('Clicking partner:', item.id, item.partner_name);
      this.$store.dispatch('partner_setcurrent',{ partner_id: item.id })
        .then(() => {
          console.log('Partner set in store, partner_id now:', this.partner_id);
        })
        .catch(err => {
          console.error('Error setting partner:', err);
        });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          partner_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('partnerlabel_add', { label: savelabel })
        .then(()=> {
          this.labels_get();
          this.conlabels_get(this.addinglabel);
          this.addinglabel = 0;
          this.addinglabeltext = '';
        });
      }
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => {
        const ref = this.$refs['l'+id];
        if (ref) {
          // In Vue 3, refs in v-for are arrays
          const element = Array.isArray(ref) ? ref[0] : ref;
          if (element && element.focus) {
            element.focus();
          }
        }
      });
    },
    removelabel(partner_id,partnerlabel_id) {
      this.$store.dispatch('partnerlabel_delete', { id: partnerlabel_id })
      .then(()=> {
        this.labels_get();
        this.conlabels_get(partner_id);
      });
    },
    partner_get(partner_id) {
      var partner_name = '';
      this.$store.dispatch('partner_fetch', { partner_id: partner_id })
      .then((resp) => {
        partner_name = resp.data.partner_name;
        for (var i=0; i<this.partners.length; i++) {
          if (this.partners[i].id == partner_id) {
            this.partners[i].partner_name = partner_name;
          }
        }
      });
    },
    conlabels_get(partner_id) {
      this.$store.dispatch('partnerlabels_fetch', { partner_id: partner_id })
      .then((resp) => {
         for (var i=0; i<this.partners.length; i++) {
           if (this.partners[i].id == partner_id) {
             this.partners[i].labels = resp.data;
           }
         }
      });
    },
    selectall() {
      // Toggle: if any are unselected, select all; if all selected, unselect all
      const allSelected = this.partners.every(p => p.selected);
      const newValue = !allSelected;
      for (var i=0;i<this.partners.length; i++) {
        this.partners[i].selected = newValue;
      }
      this.selected = newValue;
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i=0;i<this.partners.length; i++) {
          if (this.partners[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      })
    },
    partners_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.partners_filterget();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    partners_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.partners_filterget();
    },
    onLabelFilterChange(value) {
      this.filterlabel = value;
      this.partners_filterget();
    },
    partners_filterget() {
      this.currentPage = 1;
      this.partners_get();
    },
    partners_get() {
      this.loading = true;
      var filter = '';
      if (this.search != '') {
        filter = {
          partner_name: {
            operator: 'LIKE',
            value: '%'+this.search+'%',
          },
        }
      }
      this.$store.dispatch('partners_fetch', {
        start: this.currentPage,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc==false)?'ASC':'DESC',
        filter: filter,
        label_id: this.filterlabel,
        usergroup_id: this.filterusergroup,
      })
      .then((resp) => {
         this.partners = [];
         for (var i=0;i<resp.data.result.length;i++) {
           var labels = resp.data.result[i].labels;
           var result = {
             id: resp.data.result[i].id,
             selected: false,
             partner_name: resp.data.result[i].partner_name,
             labels: labels,
           }
           this.partners.push(result);
         }
         this.rows = Number(resp.data.total);
         this.loading = false;
      });
    },
    labels_get() {
      this.$store.dispatch('labels_fetch')
      .then((resp) => {
        var dblabels = resp.data.result;
        var labels = [];
        for (var i=0;i<dblabels.length;i++) {
          var option = {
            value: dblabels[i].id,
            text: dblabels[i].label,
            color: dblabels[i].color,
          }
          labels.push(option);
        }
        labels.unshift({ value: 0, text: 'All labels',color: 'ffffff' });
        this.alllabels = labels;
      });
    },
  },
}
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
.headselect {
color: red;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 30px;
  position: absolute;
  top: 20px;
}
</style>
